import { rollForwardDate } from "../objects/roll_forward_date_function"
import ConfigFile from "../../../datasets/config_file";
import findDataObject from "../../../objects/CommonUse/find_data_object";
import { applyMonthlyMiscExpToCreditCard } from "../objects/apply_monthly_misc_exp_to_credit_card";
import calculatePaymentHistory from "./calculate_payment_history";
import roundAndReturnString from "../../../objects/CommonUse/round_and_return_string";


export const payMonthlyCreditCardAmount = 
     (creditCardInfo, currentCash, currentGameDate, nbrMonths, expenseTable, spendHistCredit) => {

     if (+creditCardInfo.totalOutstandingBalance < +creditCardInfo.creditMaxAmount){
          //  the following adds on the ongoing monthly costs to the credit card and
          //  an estimated unplanned amount (based on average unplanned for current and
          //  prior months);
          creditCardInfo = applyMonthlyMiscExpToCreditCard(expenseTable, 
               creditCardInfo, +nbrMonths, spendHistCredit);
     }
     let totalOutstandingBalance = +creditCardInfo.totalOutstandingBalance;
     // update late fee if no payment was made for the previous period 
     let lateFee = 0;
     let indx = creditCardInfo.periodCreditCharges.length - 2;
     if (indx > 0){
          // update late fee if no payment was made for the previous period 
          if (+creditCardInfo.periodCreditCharges[indx].periodAmtPaid < 
               +creditCardInfo.periodCreditCharges[indx].minPayAmt){
               lateFee = +ConfigFile.unlockedFeatures.creditCardLateFee;
               creditCardInfo.periodCreditCharges[indx + 1].periodLateFee = lateFee;
               totalOutstandingBalance += lateFee;
               creditCardInfo.lateFeeCount = (+creditCardInfo.lateFeeCount + 1).toString();
          }
     }
  
     //  calculate interest on prev period's outstanding balance
     let totalInterestCharge = 0;
     const prevPeriodOutstandBalance = +creditCardInfo.prevPeriodOutstandBalance;
     let creditCardIntRate = +(ConfigFile.unlockedFeatures.creditCardInterest/12).toFixed(6);
     let periodInterestCharge = prevPeriodOutstandBalance * creditCardIntRate * nbrMonths;
     totalInterestCharge = +totalInterestCharge + +periodInterestCharge;
     creditCardInfo.totalIntBilled = (+creditCardInfo.totalIntBilled + +totalInterestCharge).toFixed(4);
     totalOutstandingBalance += totalInterestCharge;
    
     // calculate the minimum payment    
     let minPaymentPercent = ConfigFile.unlockedFeatures.creditCardMinimumPayPct;
     let minimumPaymentAmt = (+totalOutstandingBalance * minPaymentPercent + lateFee).toFixed(2);
     if (totalOutstandingBalance > +creditCardInfo.creditMaxAmount){
          let differenceAmt = +totalOutstandingBalance - +creditCardInfo.creditMaxAmount;
          // difference amount is the amount over the max credit card allowed 
          if (differenceAmt > minimumPaymentAmt){
               minimumPaymentAmt = differenceAmt;
          }
     }
     
     let expectedPayAmt = 0 ;
     if (creditCardInfo.paymentPolicyCode === "autoPayMin"){
          expectedPayAmt = minimumPaymentAmt;
     }
     if (creditCardInfo.paymentPolicyCode === "autoPayFull"){
          expectedPayAmt = totalOutstandingBalance;
     }

      // update outstanding amt, interest amt and amount paid in the current month
     indx = creditCardInfo.periodCreditCharges.length - 1;
     if (indx >= 0){
          creditCardInfo.periodCreditCharges[indx].minPayAmt = roundAndReturnString(minimumPaymentAmt,2);
          creditCardInfo.periodCreditCharges[indx].periodBilledAmt = +totalOutstandingBalance.toFixed(2);
          creditCardInfo.periodCreditCharges[indx].periodIntAmt = totalInterestCharge.toFixed(4);
          // adding to period amt paid in case player has made manual payments to card that were
          // applied in the unlocked features part of the game.
          creditCardInfo.periodCreditCharges[indx].periodAmtPaid = (+expectedPayAmt + 
               +creditCardInfo.periodCreditCharges[indx].periodAmtPaid).toFixed(2);
     }

     // apply payment for this period
     let cashError = false;
     let newCashAmt = +currentCash;
     if (+expectedPayAmt > 0){
          if (+currentCash < +expectedPayAmt){
               //  cashError set to true will cause a notification in game-board
               cashError = true;
               expectedPayAmt = +currentCash;
          }
          newCashAmt -= +expectedPayAmt;
          totalOutstandingBalance = 
               (+totalOutstandingBalance - +expectedPayAmt).toFixed(2);
     }
     
     const amtPaid = expectedPayAmt;

     const paymentHistory = calculatePaymentHistory(creditCardInfo.paymentHistory, currentGameDate,
          nbrMonths, minimumPaymentAmt, amtPaid, "endOfMonth");
     creditCardInfo.paymentHistory = paymentHistory;
          
     // create new month values
     let newMonthCreditObj = JSON.parse(JSON.stringify(findDataObject("periodCreditCharges"))).creditInfo;
     newMonthCreditObj.bgnDate = currentGameDate;
     if (+nbrMonths === 1){
          newMonthCreditObj.endDate = newMonthCreditObj.bgnDate;
     }else{
          const rollForwardMonths = +nbrMonths - 1;
          newMonthCreditObj.endDate = rollForwardDate(currentGameDate, rollForwardMonths);
     }
     creditCardInfo.periodCreditCharges.push(newMonthCreditObj);
     creditCardInfo.totalOutstandingBalance = roundAndReturnString(totalOutstandingBalance, 2);
     creditCardInfo.prevPeriodOutstandBalance = creditCardInfo.totalOutstandingBalance;
  
     // save # of periods of credit card history as specified in the config table
     let nbrPeriodsHistory = ConfigFile.unlockedFeatures.periodsCreditHistory;
     if (creditCardInfo.periodCreditCharges.length > nbrPeriodsHistory){
         let nbrToRemove = creditCardInfo.periodCreditCharges.length - nbrPeriodsHistory; 
         creditCardInfo.periodCreditCharges.splice(0,nbrToRemove);
     }
    
     let creditCardInfoObj = {creditCardInfo: creditCardInfo, cashAmt: newCashAmt, cashError: cashError,
          minimumPayment: minimumPaymentAmt};
   
     return creditCardInfoObj;
   
}
